import {SidebarInset, SidebarProvider, SidebarTrigger} from "./sidebar.tsx";
import {AppSidebar} from "../app-sidebar.tsx";
import {Toaster} from "./toaster.tsx";
import {Separator} from "./separator.tsx";
import FlashMessages from "@/components/flash_messages.tsx";
import {ThemeProvider} from "@/components/theme-provider.tsx";
import {ThemeToggle} from "@/components/theme-toggle.tsx";
import {ScrollProgress} from "@/components/magicui/scroll-progress.tsx";
import {League} from "@/../types/league.ts";
import {usePage} from "@inertiajs/react";
import {AnimatePresence, motion, MotionConfig} from "motion/react";
import React, {useRef} from "react";

interface LayoutProps {
    children: React.ReactNode
}

export default function Layout({children}: LayoutProps) {
    const page = usePage<{ current_league: League }>();
    const currentLeague = page.props.current_league;
    const leagueName = currentLeague && currentLeague !== ("none" as unknown as League) ? currentLeague.name : "Par-Lay";
    // main scrolls internally, so bind the progress bar + page transitions to it
    const mainRef = useRef<HTMLElement>(null);

    return (
        <ThemeProvider>
            <MotionConfig reducedMotion="user">
                <SidebarProvider>
                    <AppSidebar/>
                    <SidebarInset>
                        <ScrollProgress containerRef={mainRef}/>
                        <header
                            className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b bg-background/80 px-4 backdrop-blur">
                            <SidebarTrigger/>
                            <Separator orientation="vertical" className="h-6"/>
                            <span className="font-display text-sm font-semibold tracking-tight">{leagueName}</span>
                            <div className="ml-auto">
                                <ThemeToggle/>
                            </div>
                        </header>
                        <main ref={mainRef} className="flex-1 overflow-auto">
                            <AnimatePresence mode="wait">
                                <motion.div
                                    key={page.url}
                                    initial={{opacity: 0, y: 8, filter: "blur(2px)"}}
                                    animate={{opacity: 1, y: 0, filter: "blur(0px)"}}
                                    transition={{duration: 0.28, ease: [0.22, 1, 0.36, 1]}}
                                    className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
                                    {children}
                                </motion.div>
                            </AnimatePresence>
                        </main>
                    </SidebarInset>
                    <Toaster/>
                    <FlashMessages/>
                </SidebarProvider>
            </MotionConfig>
        </ThemeProvider>
    )
}
